import {Injectable} from "@angular/core";
import {ResourceChatRepository} from "./repository/ResourceChatRepository";
import {ResourceChat} from "../domain/resources/chat/ResourceChat";
import {ResourceChatMessage} from "../domain/resources/chat/ResourceChatMessage";
import {Observable} from "rxjs";
import {AuthService} from "./AuthService";

@Injectable({
	providedIn: 'root',
} as any)
export class ResourceChatService {

	constructor(private repo:ResourceChatRepository, private authService:AuthService) {}

	public initializeChat(resourceId:string):void {
		this.repo.ensureChat$(resourceId).subscribe({error: error => console.error(error)});
	}

	public async sendMessageToChat(resourceGuid:string, message:string):Promise<void> {
		if (!resourceGuid || !message.trim() || !this.authService.currentUserRef) { throw new Error("A signed-in sender and message are required."); }
		const entry = ResourceChatMessage.create(message.trim()).as(this.authService.currentUserRef).at();
		await this.repo.appendMessage$(resourceGuid, entry).toPromise();
	}

	public getChat$(resourceGuid:string):Observable<ResourceChat> {
		return this.repo.watch$(resourceGuid);
	}

}
